import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Api from "../../Api";
import {
  LinkNewCategoryWithPageUrlModalForm,
  ListPageUrlDetail,
} from "../../component";

const PageUrlDetail = () => {
  const { pageUrlId } = useParams();
  interface CategoryMember {
    pageURLId: number;
    categoryId: number;
    categoryName: string;
  }

  interface CategoryType {
    categoryName: string;
    categoryId: number;
  }

  const [categoryMember, setCategoryMember] = useState<CategoryMember[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<CategoryType[]>([]);

  const api = Api();

  const handleLinkCategory = (payload: { categoryId: number }) => {
    api.pageUrl
      .addPageURLCategoryMember({ ...payload, pageURLId: Number(pageUrlId) })
      .then((response: any) => {
        toast.success(response.message);
        getPageUrlRelationship();
      });
  };

  const getPageUrlRelationship = () => {
    api.pageUrl
      .getPageUrlRelationship(Number(pageUrlId))
      .then((response: any) => {
        if (response) {
          setCategoryMember([...response.categoryMembers]);
        }
      });
  };

  const handelDelete = (pageUrlId: number, categoryId: number) => {
    api.pageUrl
      .deletePageURLCategoryMember(pageUrlId, categoryId)
      .then((response: any) => {
        if (response) {
          toast.success(response.message);
          getPageUrlRelationship();
        }
      });
  };

  const fetchForDropdown = async () => {
    const categoryResponse = await api.pageUrlCategory.searchPageURLCategory({});
    setCategoryOptions([...categoryResponse.pageURLCategoryList]);
  };

  useEffect(() => {
    getPageUrlRelationship();
    fetchForDropdown();
  }, []);

  return (
    <div className="w-100">
      <div className="float-end mx-2">
        <LinkNewCategoryWithPageUrlModalForm
          onLinkNewCategory={handleLinkCategory}
          categoryListForDropdown={categoryOptions}
        />
      </div>

      <ListPageUrlDetail
        pageUrlRelationshipList={categoryMember}
        handelDelete={(categoryId: number, pageUrlId: number) =>
          handelDelete(pageUrlId, categoryId)
        }
      />
    </div>
  );
};

export default PageUrlDetail;
